import { getProductScope } from '@discover-frontend/utils';

import { prepareNewAudience } from 'src/operations/repository';
import { fetchCreateAudienceApi } from 'src/services/repositoryApi';

/** Creates a temporary repository audience and returns the item shape modals expect. */
export const createTemporaryAudienceForModal = async (
  audienceData: Record<string, unknown>
) => {
  const newAudience = prepareNewAudience(audienceData);
  newAudience.scope = getProductScope();

  const { response, error } = (await fetchCreateAudienceApi(newAudience)) as {
    response?: { data: { id: string } };
    error?: unknown;
  };
  if (error) {
    throw error;
  }

  return { ...audienceData, id: response?.data?.id };
};
